<template>
  <app-modal ref="modal" name="tax-account-connect-modal" :title="title" :is-submitting="isLoading"
    @before-open="beforeOpen" @before-close="beforeClose" @on-ok="onOk">
    <div class="tax-account-connect-modal">
      <p class="desc">{{ $t('user.connectEInvoiceSystemDesc') }}</p>
      <p class="alert alert-warning">{{ $t('user.wrongPasswordWarn') }} {{ genderMaxConnect }} {{ $t('user.wrongTime')
      }}
      </p>
      <div class="pt-3 pb-4 text-center">
        <img class="logo" src="/images/tax-logo.png" alt="CQT E-invoice logo">
      </div>
      <app-form ref="form" @on-submit="onSubmit" :schema="schema" :data="formModel" />
      <div class="information">
        <a :href="linkPVS" target="_blank" class="pvs">{{ $t('user.infor1') }}</a> {{ $t('user.infor2') }} <a
          :href="linkGDT" target="_blank" class="gdt">{{ $t('user.infor3') }}</a>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import { mapActions } from 'vuex';
import AppForm from '@/components/app-form/';
import AccountProxy from '@/store/proxies/account-proxy';
import { E_INVOICE_ROLE } from '@/app-constant';

export default {
  name: 'TaxAccountConnectModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      numberPackage: 100,
      title: this.$t('user.connectEInvoiceSystem'),
      isLoading: false,
      maxConnect: 0,
      isUpdatePassword: false,
      linkPVS: 'https://pvssolution.com/',
      linkGDT: 'https://www.gdt.gov.vn/wps/portal/!ut/p/z1/tVNLb4JAEP4r9eCR7KDAwtGiUbS0GMtrL2ZZKN3GRawb7M_vkqaHHgQa271MJvkek29nEEEJIhVteEklP1b0oPqUWHt3u3GjTQRgh8EcPN_HUejNAZ4xir8Ay9nKwA8KYCwBPOP-6XHlbnXwpogM4cOVN4M-foQIIqyStXxFaZnLO3asZFHJMZzpXvVt1Tg7j0EyxvJmDLZuWjgzqZZl8KIZtNA1R88c1TqGk00sk9K8Fb0wwWUheI7SoZSaDUbHfcGS7lji1u-HQrBQeftbbFlYn9ie-Q3o-Jo-k1QNia8OuTZQ3PDigsLq-C7Usux-mcGq18G60aFTfrmB_5Wf3Ci_7lt-dZ387XQiM3UC7dp_SJT83Q3UIgyFPRVaAjwQbmb7i6lZin1bDuVo9AkmTOe7/dz/d5/L2dBISEvZ0FBIS9nQSEh/',
      formModel: {
        user_name: null,
        password: null,
        invoices_sold: null,
        invoices_purchase: null,
        start_date_synchronized: null,
      },
      schema: [
        {
          name: 'user_name',
          label: this.$t('user.username'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.username')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'password',
          label: `${this.$t('user.password')}`,
          placeholder: `${this.$t('app.enter')} ${this.$t('user.password')}`,
          type: 'input',
          inputType: 'password',
          validation: 'required',
        },
      ],
    };
  },
  created() {
    const maxConnect = JSON.parse(localStorage.getItem('maxConnect'));
    if (maxConnect && !isNaN(maxConnect)) {
      this.maxConnect = Number(maxConnect);
    } else {
      localStorage.setItem('maxConnect', '5');
      this.maxConnect = 5;
    }
  },
  computed: {
    genderMaxConnect() {
      return this.maxConnect;
    },
  },
  methods: {
    ...mapActions('auth', [
      'updateCompanyInfo',
      'updateCompanyTaxAccount',
      'updateLicense',
      'updateEInvoiceRole',
      'getSubscriptionsMonitor',
    ]),
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          if (this.isUpdatePassword) {
            this.updatePassword(formModel);
          } else {
            this.connectTaxAccount(formModel);
          }
        }
      });
    },
    connectTaxAccount(formModel) {
      const syncDate = new Date();
      const yearTwoYearsAgo = syncDate.getFullYear() - 2;
      syncDate.setFullYear(yearTwoYearsAgo);

      const payload = {
        user_name: formModel.user_name,
        password: formModel.password,
        invoices_sold: true,
        invoices_purchase: true,
        start_date_synchronized: '2024-01-01',
      };
      this.isLoading = true;
      new AccountProxy().connectTaxAccount(payload)
        .then(() => {
          sessionStorage.setItem('isConnectTaxAccount', '1');
          this.$refs.modal.close();
          this.$bus.emit('tax-account-connect-success');
          this.getSubscriptionsMonitor();
          this.onSuccessConnect();
          this.onOpenDialog();
        })
        .catch((error) => {
          if (error.status_code === 401) {
            this.countMaxConnect();
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    updatePassword(formModel) {
      const payload = {
        user_name: formModel.user_name,
        password: formModel.password,
      };

      this.isLoading = true;

      this.updateCompanyTaxAccount(payload)
        .then(() => {
          sessionStorage.setItem('isConnectTaxAccount', '1');
          this.$refs.modal.close();
          this.$bus.emit('tax-account-connect-success');
        })
        .catch((error) => {
          console.log('error: ', error);
          let message = this.$t('app.updatingError');

          if (error && error.message_code) {
            const key = 'app.' + error.message_code;
            const translated = this.$t(key);

            if (translated !== key) {
              message = translated;
            } else if (error.message) {
              message = error.message;
            }
          } else if (error && error.message) {
            message = error.message;
          }

          this.$toast.error(message);


          if (error && (error.status_code === 400 || error.status_code === 401)) {
            this.countMaxConnect();
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    countMaxConnect() {
      if (this.maxConnect > 0) {
        this.maxConnect -= 1;
        localStorage.setItem('maxConnect', this.maxConnect);
      }
    },
    onOpenDialog() {
      this.$modal.show('dialog', {
        title: '',
        isAlert: true,
        content: `
          <div class="d-flex flex-column justify-content-center align-items-center text-center">
            <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4269_2005)">
                <path d="M16.5 27.5L25.5 37L40.5 18" stroke="#00B57F" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="28.5" cy="28" r="26" stroke="#00B57F" stroke-width="4"/>
              </g>
              <defs>
                <clipPath id="clip0_4269_2005">
                    <rect width="56" height="56" fill="white" transform="translate(0.5)"/>
                </clipPath>
              </defs>
            </svg>
            <strong class="mt-3" style="color: #00B57F; font-size: 20px; font-weight: 600">${this.$t('dialog.tax-account-connect-success.content.infor-1')}</strong>
            <p class="mt-1 mb-0">
              ${this.$t('dialog.tax-account-connect-success.content.infor-2')}
              <strong style="color: #005DCA">${this.$t('dialog.tax-account-connect-success.content.package')}</strong>
              ${this.$t('dialog.tax-account-connect-success.content.infor-3')}
            </p>
          </div>
        `,
      });
    },
    onSuccessConnect() {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        this.updateLicense(this.numberPackage);
        if (!currentUser.einvoicerole) {
          this.updateEInvoiceRole(E_INVOICE_ROLE);
        }
      }
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeClose() {
      this.isUpdatePassword = false;
    },
    beforeOpen(params) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.company && currentUser.company.tax_code) {
        this.formModel.user_name = currentUser.company.tax_code;
      }
      this.isUpdatePassword = params.model.isUpdatePassword || false;
    },
  },
};
</script>
<style scoped>
.tax-account-connect-modal {
  .alert {
    text-align: center;
    font-size: 13px;
  }

  .desc {
    font-size: 13px;
    text-align: center;
    padding: 1rem;
    background: #CCE4F6;
    border-radius: 8px;
  }

  .information {
    font-size: 14px;
    padding-top: 16px;
    margin-top: 24px;
    border-top: 0.5px solid #CCE4F6;

    .pvs {
      font-weight: bolder;
      color: #000000;
    }

    .gdt {
      font-weight: bold;
      color: #005DCA
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/user/tax-account-connect-modal.vue